exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.error-page {\n    font-family: Arial, sans-serif;\n    background-color: #D3D3D3;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    height: 100vh;\n}\n\n.error-container {\n    text-align: center;\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\nh1 {\n    font-size: 5rem;\n    color: #444444;\n}\n\np {\n    font-size: 1.5rem;\n    color: #444;\n    margin-bottom: 20px;\n}\n\na {\n    text-decoration: none;\n    background-color: #444444;\n    color: #fff;\n    padding: 10px 20px;\n    border-radius: 3px;\n    font-weight: bold;\n    transition: background-color 0.3s ease;\n}\n\na:hover {\n    background-color: #151515;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/components/not-found/not-found.component.css
// module id = ../../../../../src/app/components/not-found/not-found.component.css
// module chunks = main